import { h } from 'preact';
import { useState, useRef, useEffect } from 'preact/hooks';

export const navUpdate = p => navUpdate2(p);
let navUpdate2 = () => { };
export const menuNav = function(p1) {
  const [update, setUpdate] = useState(false);
  const [p2, setp2] = useState({});
  navUpdate2 = p => {
    setUpdate(u => !u);
    if (typeof p === 'object') setp2(p);
  };
  const p = Object.assign({}, p1, p2);
  const sel = p.sel || 'h1,h2,h3,h4';
  const el = (p.el && p.el.querySelectorAll) ? p.el : document;
  let items = [...el.querySelectorAll(sel)];
  useEffect(() => {
    window.addEventListener('scroll', navScroller);
    return () => window.removeEventListener('scroll', navScroller);
  });
  if (p.addl) items.splice(items.length, 0, ...p.addl);
  items = items.map(x => ({ el: x, r: x.getBoundingClientRect() }));
  if (p.asel) fillAsel(items, el, p.asel);
  return h('ul', { class: 'pre-nav-list' },
    items.map((o, i) => h(myLi, { ...o, i, items, update })),
  );
};

function myLi({ el, r, a, i, items, update }) {
  const ref = useRef();
  const off = 10;
  const ntop = (items[i + 1] || { r: { top: off + 1 } }).r.top;
  const isCurrent = r.top <= off && ntop > off;
  useEffect(() => {
    if (isCurrent) {
      ref.current.scrollIntoView({
        block: 'center', inline: 'center',
      });
    }
  }, [r, update]);
  return h('li', { ref: ref, onClick: ev => el.scrollIntoView() },
    (a ? em() : ''), (isCurrent ? '*** ' : ''), pct(r, window.scrollY),
    ' - ', el.textContent.substr(0, 40) + '...',
  );
}

const em = (w = 2) => h('span',
  { style: { width: w + 'em', display: 'inline-block' } }, ' ');

function pct(rect, t = 0, prm = 'top') {
  return Math.round((rect[prm] + t) / window.innerHeight);
}

let dScroll = null;
function navScroller(e) {
  if (dScroll) clearTimeout(dScroll);
  dScroll = setTimeout(function() {
    navUpdate();
    dScroll = null;
  }, 200);
}

function fillAsel(arr, el, asel) {
  // const thr = window.innerHeight / 10;
  if (!arr || !arr.length) { return; }
  let iEnd = arr.findIndex(x => x.r.top >= 10);
  const rng = document.createRange();
  if (iEnd <= 0) {
    iEnd = arr.length;
    rng.selectNodeContents(el);
  } else rng.setEndBefore(arr[iEnd].el);

  const el0 = arr[iEnd - 1].el;
  if (el0.asel) asel = el0.asel;
  if (el0.attributes.asel) asel = el0.attributes.asel.value;
  rng.setStartAfter(el0);
  const arr2 = [...el.querySelectorAll(asel)]
    .filter(x => rng.intersectsNode(x))
    .map(x => ({ el: x, r: x.getBoundingClientRect(), a: 1 }));
  arr.splice(iEnd, 0, ...arr2);
}
